<div>
  <mat-card appearance="outlined" class="page page-narrow">
    <mat-card-subtitle>
      {{ 'APP_INSUFFICIENT_PERMISSION.TITLE' | translate }}
    </mat-card-subtitle>
  </mat-card>
</div>
